export default function nombreUsuario(idUsuario, usuarios) {
    let nombre = "";
    try {
        for (let i = 0; i < usuarios.length; i++) {
            if (Number(idUsuario) === usuarios[i].userID){
                const {name, lastName, surname} = usuarios[i];
                nombre = `${name} ${lastName} ${surname}`.toUpperCase();
                break;
            } 
        }
    } catch (error) {
        console.log(error)
    }
    finally {
        return nombre;
    }

}